<template>
    <base-dialog ref="base">
        <v-card>
            <v-card-title>
                Закупка "{{ purchase.title }}"
            </v-card-title>
            <v-card-subtitle>
                Настройка дозаказа
            </v-card-subtitle>
            <v-card-text>
                <div class="subtitle-2 mb-2">
                    Дозаказа по точкам
                </div>
                <v-radio-group v-model="purchase.backorder_settings.type">
                    <v-radio
                        v-for="i in type_items"
                        :key="i.value"
                        :label="i.text"
                        :value="i.value"
                    ></v-radio>
                </v-radio-group>
                <div class="mt-2" :style="{'color': purchase.backorder_settings.type === 'W' ? 'lightgrey' : 'grey'}">
                    Примеры (Садовод):<br/>
                    Все места Линии 22 = <strong>22-*</strong><br/>
                    Все места Старого ТЦ, 1-го этажа, линии Б = <strong>1-Б-*</strong><br/>
                    <span style="font-weight: 900; font-size: 2rem; position: relative; top: 11px">*</span> -
                    равносильно любому символу и кол-ву символов
                </div>
                <v-select hide-details dense outlined
                          class="mt-3"
                          label="Условие"
                          :disabled="purchase.backorder_settings.type === 'W'"
                          :items="condition_items"
                          v-model="purchase.backorder_settings.condition"></v-select>
                <v-combobox
                    outlined
                    :disabled="purchase.backorder_settings.type === 'W'"
                    :menu-props="{
                                    closeOnClick: false, closeOnContentClick: true, disableKeys: true, openOnClick: false, maxHeight: 179
                                 }"
                    v-model="purchase.backorder_settings.places"
                    class="mt-2"
                    label="Укажите места" chips
                    deletable-chips
                    multiple></v-combobox>

            </v-card-text>
            <v-card-actions>
                <v-container fluid class="py-0">
                    <v-row>
                        <v-col cols="12" class="pb-1 pt-2 text-right">
                            <v-btn @click="$refs.base.hide()" class="btn btn-h">
                                Готово
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </base-dialog>
</template>

<script>
import BaseDialog from "../utils/BaseDialog";
import EventBus from "../../event-bus";

export default {
    name: "SettingsBackorderDialog",
    components: {BaseDialog},
    data() {
        return {
            purchase: {
                backorder_settings: {}
            },

            type_items: [
                {text: 'Не пройденные (где есть заказы в ожидании)', value: 'W'},
                {text: 'Указанные', value: 'C'},
                {text: 'Указанные и не пройденные', value: 'A'},
            ],

            condition_items: [
                {text: 'Все', value: 'E'},
                {text: 'Всё кроме', value: 'F'}
            ]
        }
    },
    methods: {},
    created() {
        const vm = this;
        EventBus.$on('settings_backorder_dialog', function (purchase) {
            if (vm.$refs.base !== undefined) {
                vm.$refs.base.show();
            }
            vm.$set(vm, 'purchase', purchase)
        })
    }
}
</script>